/* ------------------------------------------------------------------------
Copyright (c) 2016, VoiceVibes, Inc

VoiceVibes, Inc - PROPRIETARY/CONFIDENTIAL
All contents of this file are proprietary and confidential. No part of
any of the contents of this file may be disclosed in any manner to
a third party without the prior written consent of VoiceVibes, Inc.
Unauthorized copying of this file, via any medium is strictly prohibited.
----------------------------------------------------------------------------- */

<template>
  <div
    class="col-lg-10"
  >
    <form @submit.prevent="save">
      <h2>
        Customize Wordspotting
      </h2>

      <div v-if="wordsType === 'org' || wordsType === 'global'">
        Below is the {{ (wordsType === 'org') ? 'custom wordspotting list configured on the Org' : 'default wordspotting list' }}
        which will be used for
        this assignment, unless custom Group or User wordspotting is also in place.
        <br><br>
        To make changes to the wordspotting list used for this assignment, add or remove the desired
        phrases below then click the "Save and Continue" button. Enter 1 phrase in each input box. Each phrase
        can be a maximum of 100 characters long and you can enter up to 25 total phrases.
      </div>
      <div v-if="wordsType === 'assignment'">
        Below is the custom wordspotting list configured on this assignment.
        <br><br>
        To make changes to this list, add or remove the desired
        phrases below then click the "Save and Continue" button. To remove this assignment-specific configuration,
        uncheck and save the "Add custom wordspotting" checkbox on the <strong>prior</strong> screen.
      </div>
      <br>

      <div v-for="(word, index) in words">
        <input
          :id="'word' + index"
          :key="index"
          type="text"
          class="wordspotting-phrase"
          :value="word"
          maxlength="100"
          @click.prevent="phraseClicked"
          @blur.prevent="phraseBlurred"
          @keydown="phraseBlurred"
        >
      </div>

      <br><br><br>

      <button
        type="button"
        class="btn clear-btn"
        @click="$emit('rewindAssignmentEditor')"
      >
        Cancel / Previous
      </button>
      <loading-button
        style="float:right"
        :loading="saving"
      >
        Save and Continue
      </loading-button>
    </form>
  </div>
</template>

<style lang="less" scoped>
  .wordspotting-phrase {
    width: 150px;
    margin: 5px;
  }
</style>

<script>
import WordspottingMixin from '../pages/WordspottingMixin';

export default {
  mixins: [ WordspottingMixin ],
  props: [ 'assignment' ],
  data() {
    return {
      errors: [],
      saving: false,
      wordspotting: null,
      words: null,
      originalWords: null,
      wordsType: 'global',
    };
  },
  computed: {
    org() {
      return this.$store.getters.org;
    },
    activeGroups: {
      cache: false,
      get() {
        return this.$store.getters.activeGroups;
      }
    }
  },
  created() {
    /*
    if (!this.assignment.criteria.wordspotting) {
      return this.$emit('advanceAssignmentEditor');
    }
    */

    this.$store.dispatch('listWordspotting')
      .then(() => {
        this.wordspotting = this.$store.getters.wordspotting;
        const defaultAlgo = this.org.algorithmConfig.default_algorithm;

        if (this.assignment.wordspotting) {
          this.words = this._.clone(this.assignment.wordspotting);
          this.wordsType = 'assignment';
        } else if (this.wordspotting.org && defaultAlgo in this.wordspotting.org) {
          this.words = this._.clone(this.wordspotting.org[defaultAlgo].words);
          this.wordsType = 'org';
        } else {
          this.words = this._.clone(this.wordspotting.global[defaultAlgo].words);
          this.wordsType = 'global';
        }
        this.originalWords = this._.clone(this.words);

        // Add 2 empty words to the input boxes
        this.addEmptyWord();
        this.addEmptyWord();
      });
  },
  methods: {
    save() {
      if (!this.trimAndValidateTheWords()) {
        return;
      }
      this.saving = true;
      this.assignment.wordspotting = this.words;

      this.$store.dispatch('updateAssignment', {assignment: this.assignment, updateWordspotting: true})
        .then(() => {
          // Advance to the next form
          this.$emit('advanceAssignmentEditor');
        })
        .catch(() => {
          this.saving = false;
        });
    },
  }
};
</script>
